"use client";
import { createContext, useContext } from "react";
export const AuthModalContext = createContext(undefined);
// eslint-disable-next-line jsdoc/require-jsdoc
export const useAuthContext = () => {
    const context = useOptionalAuthContext();
    if (!context) {
        throw new Error("useAuthModalContext must be used within a AuthModalProvider");
    }
    return context;
};
// eslint-disable-next-line jsdoc/require-jsdoc
export const useOptionalAuthContext = () => useContext(AuthModalContext);
//# sourceMappingURL=context.js.map